import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { PrivateDocumentCategory } from '@/shared/lib/sj-orm/models/document/private.document.dto';

export const useI18nValues = () => {
  const { t } = useTranslation('entities/privateDocuments', { keyPrefix: 'types' });

  return useMemo(
    () => ({
      category: (category: PrivateDocumentCategory) => t(i18nMap[category]),
    }),
    [t],
  );
};

const i18nMap = {
  [PrivateDocumentCategory.BANK_DOCUMENTS]: 'bankDocuments',
  [PrivateDocumentCategory.CORPORATE_DOCUMENTS]: 'corporateDocuments',
  [PrivateDocumentCategory.FAMILY_DOCUMENTS]: 'familyDocuments',
  [PrivateDocumentCategory.INFORMATION_SHEETS]: 'informationSheets',
  [PrivateDocumentCategory.OTHER]: 'other',
  [PrivateDocumentCategory.PAYMENT_DOCUMENTS]: 'paymentDocuments',
  [PrivateDocumentCategory.POWERS]: 'powers',
  [PrivateDocumentCategory.PRIVATE_AGREEMENTS]: 'privateAgreements',
  [PrivateDocumentCategory.PUBLIC_AGREEMENTS]: 'publicAgreements',
};
